import { Button } from "@mui/material";
import React from "react";

const DashTabs = (props) => {
    const {show,setShow,setView,setUpdateData} = props
  return (
    <div className="Dash-table mt-4" style={{ height: "50px" }}>
      <div style={{ float: "right" }}>
        {/* {PermissionCheck("medicine_master", "add") && ( */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              id="btn"
              style={{ padding: show ? "10px" : "10px" }}
              onClick={() => {
                setShow(!show);
                setUpdateData([])
                setView(false)
              }}
            >
              {show ? "x  Close" : "+ Add Lab"}{" "}
            </Button>
          </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default DashTabs;
